<template>
  <!-- PAGE : BLOG -->
  <section id="blog">
    <div class="content">
      <section-title
        extraClasses="center"
        title="SOME ASSEMBLY REQUIRED..."
        icon="fas fa-volume-mute"
      />

      <!-- LATEST POSTS -->
      <div
        v-if="!loading"
        class="latest-posts media-grid"
        v-images-loaded:on.done="init"
        v-images-loaded:on.error="init"
        data-layout="fitRows"
      >
        <!-- post -->
        <blog-card
          v-for="(items, index) in blogs"
          :key="index"
          v-bind="items"
        ></blog-card>
        <!-- post -->
      </div>
      <!-- LATEST POSTS -->
    </div>
    <p class="launch">
<!--      <router-link to="blog" class="button">SEE ALL POSTS</router-link>-->
    </p>
  </section>
  <!-- PAGE : BLOG -->
</template>
<script>
import imagesLoaded from "vue-images-loaded";
import Isotope from "isotope-layout";

// import BLOGALLCARD from "@/json/blogAllCard";

export default {
  directives: { imagesLoaded },
  data() {
    return {
      loading: false,
      // blogs: BLOGALLCARD
      blogs: []
    };
  },
  methods: {
    fetchBlog() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.$axios
        .get("/blog")
        .then(res => {
          this.blogs = res.data;
        })
        .catch(e => {
          console.log(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    init() {
      let itemW = 360;
      let containerW = window.$(".latest-posts").width();
      let columns = Math.round(containerW / itemW);
      if (this.isotope) {
        this.isotope.arrange({
          masonry: {
            columnWidth: Math.floor(containerW / columns)
          }
        });
        this.isotope.layout();
        setTimeout(() => {
          this.init();
        }, 1000);
      } else {
        this.isotope = new Isotope(".latest-posts", {
          // options
          itemSelector: ".media-cell",
          layoutMode: "masonry",
          masonry: {
            columnWidth: Math.floor(containerW / columns)
          }
        });
      }
    }
  },
  beforeMount() {
    this.fetchBlog();
  },
  mounted() {
    this.$nextTick(function() {
      window.addEventListener("resize", this.init);
    });
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.init);
  }
};
</script>
